import { action } from 'satcheljs';

export const openComposeSchedulingAssistant = action(
    'openComposeSchedulingAssistant',
    (formId: string) => ({
        formId,
    })
);

// TODO: fix circular dependency with CalendarEventData
// https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/117262
export const handleSchedulingAssistantSave = action(
    'handleSchedulingAssistantSave',
    (formId: string, finalState: any, isAllDayEventExplicitlySet: boolean) => ({
        formId,
        finalState,
        isAllDayEventExplicitlySet,
    })
);

export const handleSchedulingAssistantDiscard = action(
    'handleSchedulingAssistantDiscard',
    (formId: string) => ({
        formId,
    })
);

export const closeComposeSchedulingAssistant = action(
    'closeComposeSchedulingAssistant',
    (formId: string) => ({
        formId,
    })
);
